import styled from "styled-components";

export const ContainerCategoryDetail = styled.div `
    padding: 40px 0;
    background: #ffffff;
    margin: 0px 100px;
    border-radius: 4px;
    flex: 1 1 auto; 
     @media (max-width: ${props => props.theme.breakpoints.md}){
        margin: 0px;
        background: transparent;         
        box-shadow:none;
    } 
`